import React from 'react';
import './App.css';

import Header from './components/header'
import Footer from './components/footer'
import Tagline from './components/tagline'
import Section from './components/section'

// import logo from './resources/logo.svg';

const App = ({heading, tagLine, sections, footer}) => {
    return (
      <div className="App">
        <Header title={heading}/>
        <div className="AppContent">
          <Tagline text={tagLine} />
          {sections.map(s => <Section key={s.id} {...s} />)}
        </div>
        <Footer {...footer}/>
      </div>
    );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js